import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultEnergyProductionCoordinateStyles =
  makeStyles((theme) => ({
    root: {
      fontWeight: theme.typography.fontWeightBold,
    },
  }));
